import { all, call, put, takeLatest } from 'redux-saga/effects'

import { MARK_STREAM_AS_READ } from './actions'

import { getActivityStreamService, markActivityStreamService } from './index'

interface MarkStreamAsReadPayload {
  data: unknown
}

export function* markStreamAsReadSaga({
  payload: { data },
}: {
  payload: MarkStreamAsReadPayload
}): Generator<unknown, void, unknown> {
  yield call(
    markActivityStreamService.requestSaga as (opts: { payload: { data: unknown } }) => Generator,
    {
      payload: { data },
    },
  )
  yield put(getActivityStreamService.actions.request())
}

export default function* saga(): Generator<unknown, void, unknown> {
  yield all([
    takeLatest(
      MARK_STREAM_AS_READ as Parameters<typeof takeLatest>[0] extends string ? string : never,
      markStreamAsReadSaga,
    ),
  ])
}
